<template>
  <loading v-if="isLoading"></loading>
  <not-found v-else-if="!project"></not-found>
  <div v-else>
    <project-info
      drawer
      class="u-border u-margin-bottom"
      :project="project"
    ></project-info>

    <div class="row">
      <div
        class="es-xs-6"
        v-for="battery in project.batteryInfo"
        :key="battery.id"
      >
        <BatteryDrawerDetail
          :force="false"
          :batteryId="battery.id"
        ></BatteryDrawerDetail>
      </div>
    </div>
  </div>
</template>

<script>
import NotFound from "../Base/NotFound.vue";
import BatteryDrawerDetail from "../Batteries/BatteryDrawerDetail.vue";
import ProjectInfo from "../ProjectDetail/ProjectInfo.vue";
export default {
  components: { BatteryDrawerDetail, NotFound, ProjectInfo },
  props: {
    projectItem: {
      type: Object,
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      project: null,
      isLoading: true,
    };
  },
  computed: {
    evaporatorBattery() {
      return (
        this.project.batteryInfo.find(
          (battery) => battery.type === "Evaporator"
        ) || {}
      );
    },
    condenserBattery() {
      return (
        this.project.batteryInfo.find(
          (battery) => battery.type === "Condenser"
        ) || {}
      );
    },
  },
  methods: {
    async getProject() {
      this.isLoading = true;
      if (this.projectItem?.id) {
        this.project = this.projectItem;
      } else {
        const response = await this.$store.dispatch("getProjectById", {
          id: this.projectId,
        });
        if (response.message === "OK") {
          this.project = response.data;
        }
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.getProject();
  },
};
</script>

<style></style>
